// extracted by mini-css-extract-plugin
export var addressFields = "_pq-0";
export var animationContainer = "_pq-1";
export var footer = "_pq-2";
export var lineItems = "_pq-3";
export var modalContent = "_pq-4";
export var orderName = "_pq-5";
export var strong = "_pq-6";
export var warning = "_pq-7";